import React from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { number } from 'prop-types';

import whatsAppLogo from '~assets/whatsapp-logo.png';

import { withIntercomHeight } from '../../constants';

import styles from './styles.module.scss';

const WhatsAppButton = ({ height }) => {
  const { whatsappNumber, enabledWhatsappNumber } =
    useSelector((state) => state.searchStore.currentSubsidiary) || '';
  const { bottom20, bottom90 } = styles;
  const setButtonHeight = height === withIntercomHeight ? bottom90 : bottom20;
  return enabledWhatsappNumber && !!whatsappNumber ? (
    <a
      target="_blank"
      href={`https://wa.me/${whatsappNumber}`}
      className={cn(styles.container, setButtonHeight)}
      rel="noopener noreferrer">
      <img className={styles.logo} src={whatsAppLogo} />
    </a>
  ) : null;
};

WhatsAppButton.propTypes = {
  height: number
};

export default WhatsAppButton;
